import React from "react";
import { useEffect } from "react";

const TermsOfService = () => {
  return (
    <section className='section-center mt-5 terms-section'>
      <h2>TERMINI DI SERVIZIO E INFORMATIVA SULLA PRIVACY</h2>
      <p>Ultimo aggiornamento: 2 Marzo 2026</p>
      <p>
        La presente sezione descrive i Termini di Servizio e l'Informativa sulla
        Privacy, descrive le nostre politiche e procedure sulla raccolta,
        l'utilizzo e la divulgazione delle tue informazioni quando utilizzi il
        Servizio e ti informa sui tuoi diritti alla privacy e su come la legge
        ti tutela.
      </p>
      <p>
        Utilizziamo i tuoi dati personali per fornire e migliorare il Servizio.
        Utilizzando il Servizio, acconsenti alla raccolta e all'utilizzo delle
        informazioni in conformità con la presente Informativa sulla privacy.
      </p>
      <h2>Interpretazione e definizioni</h2>
      <h3>Interpretazioni</h3>
      <p>
        Le parole le cui lettere iniziali sono maiuscole hanno significati
        definiti alle seguenti condizioni. Le seguenti definizioni avranno lo
        stesso significato indipendentemente dal fatto che appaiano al singolare
        o al plurale.
      </p>
      <h3>Definizioni</h3>
      <p>Ai fini della presente Informativa sulla privacy:</p>
      <ul>
        <li>
          <p>
            <strong>Account</strong> indica un account univoco creato per
            consentirti di accedere al nostro Servizio o a parti del nostro
            Servizio.
          </p>
        </li>
        <li>
          <p>
            <strong>Affiliata</strong> indica un'entità che controlla, è
            controllata da, o è sotto il controllo comune di una parte, dove per
            "controllo" si intende la proprietà del 50% o più delle azioni,
            partecipazioni azionarie o altri titoli che danno diritto al voto
            per l'elezione di amministratori o altri organi di gestione.
          </p>
        </li>
        <li>
          <p>
            <strong>Applicazione</strong> si riferisce a Ti Pianto Per Amore, il
            programma software fornito dalla Società.
          </p>
        </li>
        <li>
          <p>
            <strong>Associazione</strong> (denominata
            &quot;l'Associazione&quot;, &quot;Noi&quot;, &quot;Ci&quot; o
            &quot;Nostro&quot; nel presente contratto) si riferisce agli Amici
            di Ernest Verner, C.da Gravinella 60, Fasano(Br).
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies</strong> sono piccoli file che vengono salvati sul
            tuo computer, dispositivo mobile o qualsiasi altro dispositivo da un
            sito web, contenenti i dettagli della tua cronologia di navigazione
            su quel sito web, tra i suoi molteplici utilizzi.
          </p>
        </li>
        <li>
          <p>
            <strong>Paese</strong> si riferisce a: Italia
          </p>
        </li>
        <li>
          <p>
            <strong>Dispositivi</strong> si intende qualsiasi dispositivo in
            grado di accedere al Servizio, come un computer, un telefono
            cellulare o un tablet digitale.
          </p>
        </li>
        <li>
          <p>
            <strong>Dati Personali</strong> sono tutte le informazioni relative
            a una persona fisica identificata o identificabile.
          </p>
        </li>
        <li>
          <p>
            <strong>Servizio</strong> si riferisce all'Applicazione o al Sito
            Web o a entrambi.
          </p>
        </li>
        <li>
          <p>
            <strong>Fornitore di servizi</strong> indica qualsiasi persona
            fisica o giuridica che elabora i dati per conto della Società. Si
            riferisce a società terze o individui impiegati dalla Società per
            agevolare il Servizio, fornire il Servizio per conto della Società,
            eseguire servizi correlati al Servizio o assistere la Società
            nell'analisi delle modalità di utilizzo del Servizio.
          </p>
        </li>
        <li>
          <p>
            I <strong>Dati di utilizzo</strong> si riferiscono ai dati raccolti
            automaticamente, generati dall'utilizzo del Servizio o
            dall'infrastruttura del Servizio stesso (ad esempio, la durata della
            visita di una pagina).
          </p>
        </li>
        <li>
          <p>
            Il<strong>Sito</strong> fa riferimento a Ti Pianto Per Amore,
            accessibile da{" "}
            <a
              href='https://piantala-a.onrender.com'
              rel='external nofollow noopener'
              target='_blank'
            >
              https://piantala-a.onrender.com
            </a>
          </p>
        </li>
        <li>
          <p>
            <strong>Tu</strong> indica la persona che accede o utilizza il
            Servizio, o la società o altra entità giuridica per conto della
            quale tale persona accede o utilizza il Servizio, a seconda dei
            casi.
          </p>
        </li>
      </ul>
      <h2>Raccolta e utilizzo dei dati personali</h2>
      <h3>Tipi di dati raccolti</h3>
      <h4>Dati personali</h4>
      <p>
        Durante l'utilizzo del nostro Servizio, potremmo chiederti di fornirci
        alcune informazioni di identificazione personale che possono essere
        utilizzate per contattarti o identificarti. Le informazioni di
        identificazione personale possono includere, a titolo esemplificativo ma
        non esaustivo:
      </p>
      <ul>
        <li>
          <p>Indirizzo mail</p>
        </li>
        <li>
          <p>Nome e cognome</p>
        </li>
        <li>
          <p>Numero di telefono</p>
        </li>
        <li>
          <p>Indirizzo, Stato, Provincia, CAP, Città</p>
        </li>
        <li>
          <p>Dati di utilizzo</p>
        </li>
      </ul>
      <h4>Dati di utilizzo</h4>
      <p>
        I Dati di utilizzo vengono raccolti automaticamente durante l'utilizzo
        del Servizio.
      </p>
      <p>
        I Dati di utilizzo possono includere informazioni quali l'indirizzo IP
        del tuo dispositivo (ad esempio, l'indirizzo IP), il tipo di browser, la
        versione del browser, le pagine del nostro Servizio che visiti, l'ora e
        la data della tua visita, il tempo trascorso su tali pagine, gli
        identificatori univoci del dispositivo e altri dati diagnostici.
      </p>
      <p>
        Quando accedi al Servizio tramite o per mezzo di un dispositivo mobile,
        potremmo raccogliere automaticamente determinate informazioni, tra cui,
        a titolo esemplificativo ma non esaustivo, il tipo di dispositivo mobile
        che utilizzi, l'ID univoco del tuo dispositivo mobile, l'indirizzo IP
        del tuo dispositivo mobile, il tuo sistema operativo mobile, il tipo di
        browser Internet mobile che utilizzi, gli identificatori univoci del
        dispositivo e altri dati diagnostici.
      </p>
      <p>
        Potremmo anche raccogliere informazioni che il tuo browser invia ogni
        volta che visiti il ​​nostro Servizio o quando accedi al Servizio
        tramite o tramite un dispositivo mobile.
      </p>
      <h4>Informazioni raccolte durante l'utilizzo dell'Applicazione</h4>
      <p>
        Durante l'utilizzo della nostra Applicazione, al fine di fornire le
        funzionalità della stessa, potremmo raccogliere, previa autorizzazione
        dell'Utente:
      </p>
      <ul>
        <li>
          <p>Informazioni sulla tua posizione</p>
        </li>
        <li>
          <p>
            Immagini e altre informazioni dalla fotocamera e dalla libreria
            fotografica del tuo dispositivo
          </p>
        </li>
      </ul>
      <p>
        Utilizziamo queste informazioni per fornire funzionalità del Nostro
        Servizio, per migliorarlo e personalizzarlo. Le informazioni possono
        essere caricate sui server dell'Azienda e/o di un Fornitore di Servizi
        oppure possono essere semplicemente memorizzate sul Suo dispositivo.
      </p>
      <p>
        Puoi abilitare o disabilitare l'accesso a queste informazioni in
        qualsiasi momento, tramite le impostazioni del tuo dispositivo.
      </p>
      <h4>Tecnologie di tracciamento e cookie</h4>
      <p>
        Utilizziamo cookie e tecnologie di tracciamento simili per tracciare
        l'attività sul nostro Servizio e memorizzare determinate informazioni.
        Le tecnologie di tracciamento che utilizziamo includono beacon, tag e
        script per raccogliere e tracciare informazioni e per migliorare e
        analizzare il nostro Servizio. Le tecnologie che utilizziamo possono
        includere:
      </p>
      <ul>
        <li>
          <strong>Cookie Cookie del Browser.</strong> Un cookie è un piccolo
          file che viene memorizzato sul tuo Dispositivo. Puoi impostare il tuo
          browser in modo che rifiuti tutti i Cookie o che segnali quando viene
          inviato un Cookie. Tuttavia, se non accetti i Cookie, potresti non
          essere in grado di utilizzare alcune parti del nostro Servizio. A meno
          che tu non abbia modificato le impostazioni del tuo browser in modo
          che rifiuti i Cookie, il nostro Servizio potrebbe utilizzare i Cookie.
        </li>
        <li>
          <strong>Web Beacons.</strong> Alcune sezioni del nostro Servizio e le
          nostre email possono contenere piccoli file elettronici noti come web
          beacon (anche denominati clear gif, pixel tag e single-pixel gif) che
          consentono alla Società, ad esempio, di contare gli utenti che hanno
          visitato quelle pagine o aperto un'email e per altre statistiche
          correlate del sito web (ad esempio, registrare la popolarità di una
          determinata sezione e verificare l'integrità del sistema e del
          server).
        </li>
      </ul>
      <p>
        I cookie possono essere &quot;Persistenti&quot; o &quot;di
        Sessione&quot; Cookies. I cookie persistenti rimangono sul tuo computer
        o dispositivo mobile quando sei offline, mentre i cookie di sessione
        vengono eliminati non appena chiudi il browser web. Puoi saperne di più
        sui cookie su{" "}
        <a
          href='https://www.termsfeed.com/blog/cookies/#What_Are_Cookies'
          target='_blank'
        >
          TermsFeed website
        </a>{" "}
        article.
      </p>
      <p>
        Utilizziamo sia cookie di sessione che persistenti per gli scopi
        indicati di seguito:
      </p>
      <ul>
        <li>
          <p>
            <strong>Cookie necessari/essenziali</strong>
          </p>
          <p>Tipo: Cookie di sessione</p>
          <p>Gestito da: Noi</p>
          <p>
            Scopo: Questi cookie sono essenziali per fornirti i servizi
            disponibili tramite il Sito Web e per consentirti di utilizzare
            alcune delle sue funzionalità. Aiutano ad autenticare gli utenti e a
            prevenire l'uso fraudolento degli account utente. Senza questi
            cookie, i servizi da te richiesti non possono essere forniti e noi
            utilizziamo questi cookie solo per fornirti tali servizi.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies Policy / Notice Acceptance Cookies</strong>
          </p>
          <p>Tipo: Cookie persistenti</p>
          <p>Gestito da: Noi</p>
          <p>
            Scopo: Questi cookie identificano se gli utenti hanno accettato
            l'uso dei cookie sul Sito Web.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookie di funzionalità</strong>
          </p>
          <p>Tipo: Cookie persistenti</p>
          <p>Gestito da: Noi</p>
          <p>
            Scopo: Questi cookie ci consentono di ricordare le scelte che fai
            quando utilizzi il Sito Web, come i tuoi dati di accesso o la lingua
            preferita. Lo scopo di questi cookie è offrirti un'esperienza più
            personalizzata ed evitare che tu debba reinserire le tue preferenze
            ogni volta che utilizzi il Sito Web.
          </p>
        </li>
      </ul>
      <p>
        Per maggiori informazioni sui cookie che utilizziamo e sulle tue scelte
        in merito, consulta la nostra Informativa sui cookie o la sezione Cookie
        della nostra Informativa sulla privacy.
      </p>
      <h3>Utilizzo dei tuoi dati personali</h3>
      <p>La Società può utilizzare i dati personali per i seguenti scopi:</p>
      <ul>
        <li>
          <p>
            <strong>Per fornire e mantenere il nostro Servizio</strong>, incluso
            per monitorare l'utilizzo del nostro Servizio.
          </p>
        </li>
        <li>
          <p>
            <strong>Per gestire il tuo account:</strong> per gestire la tua
            registrazione come utente del Servizio. I dati personali che
            fornisci possono darti accesso a diverse funzionalità del Servizio
            che sono disponibili per te come utente registrato.
          </p>
        </li>
        <li>
          <p>
            <strong>Per l'esecuzione di un contratto:</strong> lo sviluppo,
            l'adempimento e l'esecuzione del contratto di acquisto per i
            prodotti, articoli o servizi da Lei acquistati o di qualsiasi altro
            contratto con Noi tramite il Servizio.
          </p>
        </li>
        <li>
          <p>
            <strong>Per contattarLa:</strong> Per contattarLa tramite e-mail,
            telefonate, SMS o altre forme equivalenti di comunicazione
            elettronica, come le notifiche push di un'applicazione mobile
            relative ad aggiornamenti o comunicazioni informative relative alle
            funzionalità, prodotti o servizi contrattualizzati, inclusi gli
            aggiornamenti di sicurezza, quando necessario o ragionevole per la
            loro implementazione.
          </p>
        </li>
        <li>
          <p>
            <strong>Per fornirle</strong> notizie, offerte speciali e
            informazioni generali su altri beni, servizi ed eventi che Noi
            offriamo e che sono simili a quelli che ha già acquistato o su cui
            ha chiesto informazioni, a meno che Lei non abbia scelto di non
            ricevere tali informazioni.
          </p>
        </li>
        <li>
          <p>
            <strong>Per gestire le tue richieste:</strong> Per soddisfare e
            gestire le tue richieste a noi.
          </p>
        </li>
        <li>
          <p>
            <strong>Per trasferimenti aziendali:</strong> Potremmo utilizzare le
            tue informazioni per valutare o condurre una fusione, una cessione,
            una ristrutturazione, una riorganizzazione, uno scioglimento o altra
            vendita o trasferimento di alcuni o tutti i nostri beni, sia come
            azienda in esercizio che come parte di un fallimento, liquidazione o
            procedimento simile, in cui i dati personali in nostro possesso
            sugli utenti del nostro Servizio siano tra i beni trasferiti.
          </p>
        </li>
        <li>
          <p>
            <strong>Per altri scopi</strong>: Potremmo utilizzare le tue
            informazioni per altri scopi, come l'analisi dei dati,
            l'identificazione delle tendenze di utilizzo, la determinazione
            dell'efficacia delle nostre campagne promozionali e per valutare e
            migliorare il nostro Servizio, i prodotti, i servizi, il marketing e
            la tua esperienza.
          </p>
        </li>
      </ul>
      <p>
        Potremmo condividere le tue informazioni personali nelle seguenti
        situazioni:
      </p>
      <ul>
        <li>
          <strong>Con i fornitori di servizi:</strong> potremmo condividere le
          tue informazioni personali con i fornitori di servizi per monitorare e
          analizzare l'utilizzo del nostro Servizio e per contattarti.
        </li>
        <li>
          <strong>Per trasferimenti aziendali:</strong> potremmo condividere o
          trasferire le tue informazioni personali in relazione a, o durante le
          negoziazioni di, qualsiasi fusione, vendita di beni aziendali,
          finanziamento o acquisizione di tutta o parte della nostra attività a
          un'altra società.
        </li>
        <li>
          <strong>Con le affiliate:</strong> potremmo condividere le tue
          informazioni con le nostre affiliate, nel qual caso richiederemo a
          tali affiliate di rispettare la presente Informativa sulla privacy. Le
          affiliate includono la nostra società madre e qualsiasi altra
          sussidiaria, partner di joint venture o altre società che controlliamo
          o che sono sotto il nostro controllo comune.
        </li>
        <li>
          <strong>Con i partner commerciali:</strong> potremmo condividere le
          tue informazioni con i nostri partner commerciali per offrirti
          determinati prodotti, servizi o promozioni.
        </li>
        <li>
          <strong>Con altri utenti:</strong> quando condividi informazioni
          personali o interagisci in altro modo nelle aree pubbliche con altri
          utenti, tali informazioni possono essere visualizzate da tutti gli
          utenti e possono essere distribuite pubblicamente all'esterno.
        </li>
        <li>
          <strong>Con il tuo consenso</strong>: potremmo divulgare le tue
          informazioni personali per qualsiasi altro scopo con il tuo consenso.
        </li>
      </ul>
      <h3>Pagamenti</h3>
      <p>
        Il pagamento del Servizio avviene esclusivamente tramite piattaforma di
        pagamento elettronico gestita da un fornitore terzo specializzato
        nell'elaborazione dei pagamenti (Stripe Technology Europe Ltd. o altra
        entità del gruppo Stripe competente sul territorio).
      </p>
      <p>
        L'Associazione non raccoglie né memorizza direttamente i dati relativi
        agli strumenti di pagamento utilizzati dall'Utente (quali numeri di
        carta di credito o debito, dati bancari o altre informazioni
        finanziarie). Tali dati vengono trattati direttamente dal fornitore del
        servizio di pagamento secondo i propri termini e condizioni e la propria
        informativa sulla privacy.
      </p>
      <p>
        Effettuando un pagamento tramite il Servizio, l'Utente accetta anche i
        termini e le condizioni del fornitore del servizio di pagamento.
      </p>
      <p>
        Eventuali contestazioni, rimborsi o richieste relative alla transazione
        potranno essere soggette alle procedure previste dal fornitore del
        servizio di pagamento e alle normative vigenti.
      </p>
      <h3>Conservazione dei tuoi dati personali</h3>
      <p>
        La Società conserverà i Suoi Dati Personali solo per il tempo necessario
        alle finalità indicate nella presente Informativa sulla Privacy.
        Conserveremo e utilizzeremo i Suoi Dati Personali nella misura
        necessaria per adempiere ai nostri obblighi legali (ad esempio, se siamo
        tenuti a conservare i Suoi dati per conformarci alle leggi applicabili),
        risolvere controversie e far rispettare i nostri accordi e politiche
        legali.
      </p>
      <p>
        La Società conserverà inoltre i Dati di Utilizzo per scopi di analisi
        interna. I Dati di Utilizzo vengono generalmente conservati per un
        periodo di tempo più breve, tranne quando questi dati vengono utilizzati
        per rafforzare la sicurezza o migliorare la funzionalità del Nostro
        Servizio, o quando siamo legalmente obbligati a conservare questi dati
        per periodi più lunghi.
      </p>
      <h3>Trasferimento dei Suoi Dati Personali</h3>
      <p>
        Le Sue informazioni, inclusi i Dati Personali, vengono elaborate presso
        le sedi operative della Società e in qualsiasi altro luogo in cui si
        trovino le parti coinvolte nel trattamento. Ciò significa che queste
        informazioni potrebbero essere trasferite a – e conservate su – computer
        situati al di fuori del tuo stato, provincia, paese o altra
        giurisdizione governativa, dove le leggi sulla protezione dei dati
        potrebbero differire da quelle della tua giurisdizione.
      </p>
      <p>
        Il tuo consenso alla presente Informativa sulla privacy, seguito
        dall'invio di tali informazioni, rappresenta il tuo consenso a tale
        trasferimento.
      </p>
      <p>
        La Società adotterà tutte le misure ragionevolmente necessarie per
        garantire che i tuoi dati siano trattati in modo sicuro e in conformità
        con la presente Informativa sulla privacy e nessun trasferimento dei
        tuoi dati personali avverrà a un'organizzazione o a un paese a meno che
        non siano in atto controlli adeguati, inclusa la sicurezza dei tuoi dati
        e di altre informazioni personali.
      </p>
      <h3>Cancellazione dei tuoi dati personali</h3>
      <p>
        Hai il diritto di cancellare o richiedere la nostra assistenza per la
        cancellazione dei dati personali che abbiamo raccolto su di te.
      </p>
      <p>
        Il nostro Servizio potrebbe darti la possibilità di cancellare
        determinate informazioni su di te dall'interno del Servizio.
      </p>
      <p>
        Puoi aggiornare, modificare o cancellare le tue informazioni in
        qualsiasi momento accedendo al tuo account, se ne hai uno, e visitando
        la sezione delle impostazioni dell'account che ti consente di gestire le
        tue informazioni personali. Puoi anche contattarci per richiedere
        l'accesso, la correzione o la cancellazione di qualsiasi informazione
        personale che ci hai fornito.
      </p>
      <p>
        Tieni presente, tuttavia, che potremmo dover conservare determinate
        informazioni quando abbiamo un obbligo legale o una base giuridica per
        farlo.
      </p>
      <h3>Divulgazione dei tuoi dati personali</h3>
      <h4>Transazioni commerciali</h4>
      <p>
        Se la Società è coinvolta in una fusione, acquisizione o vendita di
        asset, i tuoi dati personali potrebbero essere trasferiti. Ti
        informeremo prima che i tuoi dati personali vengano trasferiti e
        diventino soggetti a una diversa Informativa sulla privacy.
      </p>
      <h4>Applicazione della legge</h4>
      <p>
        In determinate circostanze, la Società potrebbe essere tenuta a
        divulgare i tuoi dati personali se richiesto dalla legge o in risposta a
        valide richieste da parte delle autorità pubbliche (ad esempio, un
        tribunale o un'agenzia governativa).
      </p>
      <h4>Altri obblighi legali</h4>
      <p>
        La Società potrebbe divulgare i tuoi dati personali nella convinzione in
        buona fede che tale azione sia necessaria per:
      </p>
      <ul>
        <li>Ottemperare a un obbligo legale</li>
        <li>Proteggere e difendere i diritti o la proprietà della Società</li>
        <li>
          Prevenire o indagare su possibili illeciti in relazione al Servizio
        </li>
        <li>
          Proteggere la sicurezza personale degli Utenti del Servizio o del
          pubblico
        </li>
        <li>Proteggere dalla responsabilità legale</li>
      </ul>
      <h3>Sicurezza dei tuoi dati personali</h3>
      <p>
        La sicurezza dei tuoi dati personali è importante per noi, ma ricorda
        che nessun metodo di trasmissione su Internet o metodo di archiviazione
        elettronica è sicuro al 100%. Sebbene ci impegniamo a utilizzare mezzi
        commercialmente ragionevoli per proteggere i tuoi dati personali, non
        possiamo garantirne l'assoluta sicurezza.
      </p>
      <h2>Privacy dei minori</h2>
      <p>
        Il nostro Servizio non è rivolto a minori di 13 anni. Non raccogliamo
        consapevolmente informazioni personali identificabili da minori di 13
        anni. Se sei un genitore o un tutore e sei a conoscenza del fatto che
        tuo figlio ci ha fornito Dati Personali, ti preghiamo di contattarci. Se
        veniamo a conoscenza di aver raccolto Dati Personali da minori di 13
        anni senza la verifica del consenso dei genitori, adotteremo misure per
        rimuovere tali informazioni dai nostri server.
      </p>
      <p>
        Se dovessimo basarci sul consenso come base giuridica per il trattamento
        delle tue informazioni e il tuo Paese richiede il consenso di un
        genitore, potremmo richiedere il consenso del genitore prima di
        raccogliere e utilizzare tali informazioni.
      </p>
      <h2>Link ad altri siti web</h2>
      <p>
        Il nostro Servizio potrebbe contenere link ad altri siti web non gestiti
        da Noi. Se clicchi su un link di terze parti, verrai indirizzato al sito
        di tale terza parte. Ti consigliamo vivamente di consultare
        l'Informativa sulla privacy di ogni sito che visiti.
      </p>
      <p>
        Non abbiamo alcun controllo e non ci assumiamo alcuna responsabilità per
        il contenuto, le informative sulla privacy o le pratiche di siti o
        servizi di terze parti.
      </p>
      <h2>Modifiche alla presente Informativa sulla privacy</h2>
      <p>
        Potremmo aggiornare la nostra Informativa sulla privacy di volta in
        volta. Ti informeremo di eventuali modifiche pubblicando la nuova
        Informativa sulla privacy su questa pagina.
      </p>
      <p>
        Ti informeremo via e-mail e/o tramite un avviso ben visibile sul Nostro
        Servizio, prima che la modifica diventi effettiva e aggiorneremo la data
        di &quot;Ultimo aggiornamento&quot; nella parte superiore della presente
        Informativa sulla privacy.
      </p>
      <p>
        Si consiglia di consultare periodicamente la presente Informativa sulla
        privacy per eventuali modifiche. Le modifiche alla presente Informativa
        sulla privacy entrano in vigore al momento della pubblicazione su questa
        pagina.
      </p>
      <h2>Contattaci</h2>
      <p>
        Per qualsiasi domanda sulla presente Informativa sulla privacy, puoi
        contattarci:
      </p>
      <ul>
        <li>Via email: tipiantoperamore@gmail.com</li>
      </ul>
    </section>
  );
};

export default TermsOfService;
